'use strict';
import angular from 'angular';

/**
 * @ngdoc function
 * @name micorrApp.controller:ListArtefactsCtrl
 * @description
 * # ListArtefactsCtrl
 * Contrôlleur qui s'occupe d'afficher tous les artefacts
 */
angular.module('micorrApp')
    .controller('ListArtefactsCtrl', function ($scope, $routeParams, MiCorrService, ngProgress) {
        // Quand on lance la page, alors il se passe une requête asynchrone qui va chercher tous les artefacts
        MiCorrService.getAllArtefacts().then(function(response){
            $scope.artefacts = response.data['artefacts'];
            ngProgress.complete();
        });
    });
